import styled from "styled-components/macro";

export const AlarmYellow = styled.div`
  text-align: center;
  padding: ${({ landscape }) => (landscape ? "0" : ".25em")};

  background: yellow; // background dynamic
  color: black; //
  display: flex;
  text-align: center;
  justify-content: center;

  & div {
    margin-left: 2.8em;
  }
`;

export const AlarmBlue = styled.div`
text-align: center;
padding: .25em;
background: #20fcf8; // background dynamic
color: black; /
`;

export const AlarmWhite = styled.div`
  text-align: center;
  padding: ${({ landscape }) => (landscape ? "0" : ".25em")};
  background: white; // background dynamic
  color: red;
  display: flex;
  justify-content: space-between;
  align-content: center;

  & img {

    width:${({ landscape }) => (landscape ? "18px" : "20px")} ;
font-size: .7rem;
}
`;

export const AlarmRed = styled.div`
  text-align: center;
  padding: 0.25em;
  background: red; // background dynamic
  color: white;
  display: flex;
  justify-content: center;
  padding: ${({ landscape }) => (landscape ? "0" : ".25em")};


`;

export const AlarmArrowUpImg = styled.img`
width: auto;

height:  ${({ landscape }) => (landscape ? "15px" : "20px")};
margin-left: 1.2em;
`; 

export const AlarmAcknowledgedImg = styled.img`
/* width: 30px; */
height: auto;
width:  ${({ landscape }) => (landscape ? "20px" : "30px")};
margin-left: .2em;


`;
